import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  LanguageContext,
  SET_ATTEMPT_ID,
  SET_LANGUAGE,
  SET_TEMPLATE_CODE,
} from "../contexts/LanguageContext";
import Spinner from "../components/Spinner";
import axios from "axios";
import LanguageButton from "../components/LanguageButton";
import companyLogo from "../assets/companyLogo.png";
import languageLogo from "../assets/languageLogo.png";
import Swal from "sweetalert2";

const LanguageSelection = ({ templateCode }) => {
  const navigate = useNavigate();
  const { dispatch } = useContext(LanguageContext);

  const [isLoading, setIsLoading] = useState(true);
  const [languages, setLanguages] = useState([]);
  const [selectedLang, setSelectedLang] = useState(null);
  const [isDefault, setIsDefault] = useState(false);

  const userData = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    dispatch({ type: SET_TEMPLATE_CODE, payload: { templateCode } });
    getLanguages();
  }, []);

  const getLanguages = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/languages`,
        {
          params: { template_code: templateCode },
          headers: { "ngrok-skip-browser-warning": "true" },
        },
      );
      setLanguages(res.data.payload);
      if (res.data.payload.length === 1) {
        handleContinue(res.data.payload[0]);
      }
      if (res.data.payload.length === 0) {
        navigate("/unauthorized");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleContinue = async (lang) => {
    if (!lang) return;

    navigate(`/instruction`, {
      state: {
        template_code: templateCode,
        language: lang,
        user_id: userData.id,
      },
    });
  };

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white">
      <div
        className="w-full lg:w-[40%] flex items-center justify-center rounded-b-[40px] lg:rounded-b-none lg:rounded-r-[60px] py-10 lg:py-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(245, 158, 11, 0.1) 0%, rgba(245, 158, 11, 0.3) 29.91%, rgba(245, 158, 11, 0.7) 70.26%, #F59E0B 100%)",
        }}
      >
        <img
          src={languageLogo}
          alt="languages"
          className="w-[70%] sm:w-[55%] lg:w-[80%] object-contain"
        />
      </div>

      <div className="w-full lg:w-[60%] flex flex-col justify-center px-6 sm:px-10 lg:px-16 py-10">
        <img
          src={companyLogo}
          alt="logo"
          className="w-[140px] sm:w-[180px] mb-8 lg:mb-12"
        />

        <div className="mb-8">
          <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800">
            Choose Your
          </h2>

          <h2 className="text-2xl sm:text-3xl font-semibold">
            <span className="text-yellow-500">Preferred</span> Language
          </h2>
        </div>

        <div className="space-y-4 w-full max-w-md">
          {languages.map((lang) => (
            <LanguageButton
              key={lang.id}
              language={lang}
              selected={selectedLang?.id === lang.id}
              onClick={() => setSelectedLang(lang)}
            />
          ))}

          <label className="flex items-start gap-2 text-sm text-gray-600 mt-2">
            <input
              type="checkbox"
              checked={isDefault}
              onChange={() => setIsDefault(!isDefault)}
              className="mt-1"
            />

            <span>Mark this as my default language</span>
          </label>

          {/* Continue Button */}
          <button
            onClick={() => handleContinue(selectedLang)}
            className="mt-6 w-full bg-yellow-500 text-white py-3 rounded-lg font-medium hover:bg-yellow-600 transition"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LanguageSelection;
